import { render, staticRenderFns } from "./contract-deny-scoring.vue?vue&type=template&id=4f748ec0&scoped=true&"
import script from "./contract-deny-scoring.vue?vue&type=script&lang=js&"
export * from "./contract-deny-scoring.vue?vue&type=script&lang=js&"
import style0 from "./contract-deny-scoring.vue?vue&type=style&index=0&lang=css&"
import style1 from "./contract-deny-scoring.vue?vue&type=style&index=1&id=4f748ec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f748ec0",
  null
  
)

export default component.exports